import { isEmpty } from "lodash";

// Extend the Window interface to include gtag
declare global {
  interface Window {
    gtag?: (
      command: "config" | "event" | "set" | "js",
      targetId: string | Date,
      config?: { [key: string]: any }
    ) => void;
  }
}

export class Analytics {
  private static instance: Analytics;

  /**
   * Singleton getter method.
   *
   * @returns the single instance
   */
  public static getInstance(): Analytics {
    if (!Analytics.instance) {
      Analytics.instance = new Analytics();
    }
    return Analytics.instance;
  }

  private _initialized: boolean;
  private _measurementId: string;

  private constructor() {
    this._initialized = false;
    this._measurementId = "";
    this.initialize();
  }

  private initialize = () => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!this._initialized && !isEmpty(measurementId) && typeof window !== "undefined" && window.gtag) {
      this._measurementId = measurementId as string;
      this._initialized = true;
    }
  };

  /**
   * Called for a page view.
   *
   * @param path
   * @param query
   */
  pageview = (path: string, query?: string) => {
    const fullPath = `${path}${query ? query : ""}`;
    if (this._initialized && window.gtag) {
      window.gtag("config", this._measurementId, {
        page_path: fullPath,
      });
    } else {
      console.log(`Analytics Debug Page View: ${fullPath}`);
    }
  };

  /**
   * Called for explicit user actions.
   *
   * @param category
   * @param action
   * @param label
   */
  event = (category: string, action: string, label?: string) => {
    if (this._initialized && window.gtag) {
      window.gtag("event", action, {
        event_category: category,
        event_label: label,
      });
    } else {
      console.log(`Analytics Debug Event: ${category} -> ${action}` + (label ? ` (${label})` : ""));
    }
  };
}
